import { useAction } from '@reatom/npm-react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Eye2Icon, Tooltip } from '@blade/ui-kit'
import { PairIcon } from '@root/entities/pair/ui/common/pair-icon'
import { blacklistCurrenciesModel } from '@root/features/blacklist/blacklist-currencies/atoms'

import { PairExploreItemContext } from './pair-explore-item-context'

import type { ComponentProps } from 'react'

type Props = ComponentProps<typeof PairIcon>

export const PairExploreItemIcon = ({ pair, ...iconProps }: Props) => {
  const { withHide } = useContext(PairExploreItemContext)
  const blacklist = useAction(blacklistCurrenciesModel.hide)
  const { t } = useTranslation()
  return (
    <Root>
      <PairIcon withPreview pair={pair} {...iconProps} />
      {withHide ? (
        <Tooltip content={t('blacklist.currencies.hide-tooltip')}>
          <HideButton
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              blacklist(pair.quote)
            }}
          >
            <Eye2Icon size={12} />
          </HideButton>
        </Tooltip>
      ) : undefined}
    </Root>
  )
}

const Root = styled.div`
  pointer-events: auto;
  position: relative;
  display: grid;
  place-items: center;
`

const HideButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  height: 18px;
  width: 18px;

  border: 1px solid var(--background-5);
  background: var(--background-1);
  color: var(--text-12);

  left: calc(50% - 9px);
  bottom: -2px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.1s linear;
`

PairExploreItemIcon.HideButton = HideButton
